import React from 'react';
import classes from './SectionSeparator.module.scss';

const SectionSeparator = () => {
    return <div className={classes['sections-separator']} />;
};

export default SectionSeparator;
